import React from 'react';
import './Home.css';
import { NavBar } from '../NavBar/NavBar';
import logo from '../../assets/logomondwild.png';


export const Home = () => {
	return (
		<>
		<section className='full-height-container home-background' id='home'>	
			<div className='logo-links'>
			<img style={{width: '400px'}}
                             src={logo}
                        /> 
			<NavBar/>
			</div>
			
		</section>
		</>
	);
}